import React, { useEffect } from 'react';
import { Route, Switch, useLocation } from 'react-router-dom';
import NavbarPublic from 'components/pages/landing/NavbarPublic';
import FooterStandard from 'components/pages/landing/FooterStandard';
import Home from 'components/pages/landing/home/Home';
import PublicRoutes from './PublicRoutes';

const PublicLayout = () => {
  const { hash, pathname } = useLocation();

  useEffect(() => {
    setTimeout(() => {
      if (hash) {
        const id = hash.replace('#', '');
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({ block: 'start', behavior: 'smooth' });
        }
      }
    }, 0);
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return <>
    <NavbarPublic />
    <Switch>
      <PublicRoutes />
    </Switch>
    <FooterStandard />
  </>
};

export default PublicLayout;
